import React from "react";
import PropTypes from "prop-types";

const ProjectProgress = ({ value: v }) => {
  const { value, style } = v || {};
  return (
    <div style={{ textAlign: "center", color: style, fontWeight: "bolder" }}>
      {value}
    </div>
  );
};

ProjectProgress.propTypes = {
  value: PropTypes.object
};
export default ProjectProgress;
